const actions = {
  SET_STATE: 'modal/SET_STATE',
};
export default actions
